import PropTypes from 'prop-types'
import { CircularProgress, Box } from '@mui/material'

const Loader = (props) => {
  return (
    <Box p={15} display="flex" justifyContent="center" padding={props?.padding}>
      <CircularProgress color={props?.color ?? 'error'}  size={props?.size}/>
    </Box>
  )
}

Loader.propTypes = {
  padding: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default Loader